<div class="modal-heading" translate>forgot_password.title</div>

<form [formGroup]="forgotPasswordForm" class="modal-form">
  <mat-form-field>
    <input matInput formControlName="username" [placeholder]="'forgot_password.username' | translate"/>
  </mat-form-field>


  <div class="long-field">
    <re-captcha theme="light" (resolved)="resolved($event)" formControlName="re_captcha_response"></re-captcha>
    <div *ngIf="forgotPasswordForm?.get('recaptcha')?.touched && !!forgotPasswordForm?.get('recaptcha')?.errors"
         class="red" translate>app.common.recaptcha
    </div>
  </div>

  <div class="controls-wrapper">
    <button mat-stroked-button color="primary" mat-dialog-close>
      {{'forgot_password.cancel' | translate }}
    </button>
    <button [disabled]="forgotPasswordForm.invalid && !readyToSend" [mat-dialog-close]="forgotPasswordForm.value" color="primary" mat-flat-button (click)="doPasswordResetRequest()">
      {{'forgot_password.send' | translate}}
    </button>
  </div>
</form>
